module.exports = __webpack_public_path__ + "img/wide.467be2e4.jpg";